//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import OrderMixin from '@app/Order/order.mixin.js'

export default {
  name: 'OrderView',
  mixins: [OrderMixin],
  methods: {
    showMinAmount(shop) {
      const curr = this.getCartByShop(shop.id)[0] && this.getCartByShop(shop.id)[0].total_price
      const difference = +shop.props.min_amount - +curr
      return 0 < difference
    },
    getMinAmountText(shop) {
      const curr = this.getCartByShop(shop.id)[0] && this.getCartByShop(shop.id)[0].total_price
      const difference = this.getCurrentDecimal(+shop.props.min_amount - +curr)
      const t = `${this._('Мінімальна сума замовлення товарів')} ${shop.caption} 
        - ${this.getCurrentDecimal(+shop.props.min_amount)} ₴. ${this._('Будь ласка, додайте товарів на суму')} 
        ${difference} ${this._('₴ для оформлення замовлення')}`
      return t
    },
  },
}
